import React from 'react';
import i18n from '../../../i18n';

import { faClass } from '@/constants/icons';

import styles from './ViewToggle.module.scss';

/**
 * Toggle segmentato Carte/Tabella per le liste con vista doppia.
 * Accessibile: role="group", ogni opzione è un <button aria-pressed>.
 *
 * Props:
 * - value: 'cards' | 'table'
 * - onChange: (next) => void
 */
const OPTIONS = [
  { key: 'cards', icon: 'fa-grip', label: () => i18n.t('vista_carte', { defaultValue: 'Carte' }) },
  {
    key: 'table',
    icon: 'fa-table-list',
    label: () => i18n.t('vista_tabella', { defaultValue: 'Tabella' }),
  },
];

export default function ViewToggle({ value = 'cards', onChange }) {
  return (
    <div
      className={styles.seg}
      role="group"
      aria-label={i18n.t('vista', { defaultValue: 'Vista' })}
    >
      {OPTIONS.map((opt) => {
        const active = value === opt.key;
        const label = opt.label();
        return (
          <button
            key={opt.key}
            type="button"
            className={`${styles.segBtn} ${active ? styles.active : ''}`}
            aria-pressed={active}
            aria-label={label}
            title={label}
            onClick={() => !active && onChange?.(opt.key)}
          >
            <i className={faClass(opt.icon)} aria-hidden="true" />
            <span className={styles.label}>{label}</span>
          </button>
        );
      })}
    </div>
  );
}
